import { useMemo } from 'react'
import { CSVField } from 'hooks/useExportCSV'
import { csvColumnCreatedBy, csvColumnUpdatedBy } from 'features/UI'
import { formatDate, isDefined } from 'utils'
import { PLACEHOLDER } from 'components/column-renderers'
import { columnContentCSV } from 'features/UI/helpers/columnContentCSV'
import { createTagsColumnCSV } from 'features/Tags/models/TagsColumn'

export function useLessonCSVField() {
  return useMemo<CSVField[]>(
    () => [
      {
        label: 'Lesson Name',
        value: 'name',
      },
      {
        label: 'Link to Learn Library Article',
        value: ({ learnArticle }) =>
          isDefined(learnArticle?.name) ? learnArticle.name : PLACEHOLDER,
      },
      columnContentCSV(),
      {
        label: 'Quiz',
        value: ({ quizId }) => (isDefined(quizId) ? 'Yes' : PLACEHOLDER),
      },
      {
        label: 'Published',
        value: ({ isPublished }) => (isPublished ? 'Published' : 'Unpublished'),
      },
      createTagsColumnCSV('tags'),
      {
        label: 'Creation Date',
        value: ({ createdAt }) => formatDate(createdAt),
      },
      csvColumnCreatedBy(),
      {
        label: 'Last Edited',
        value: ({ updatedAt }) => formatDate(updatedAt),
      },
      csvColumnUpdatedBy(),
    ],
    [],
  )
}
